import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles(theme => ({
  dropdown: {
    position: 'relative',
    width: '100%',
    cursor: 'pointer',
    userSelect: 'none',
  },

  disabled: {
    backgroundColor: theme.colors.lightGray.dark,
    color: theme.colors.background.text,
    cursor: 'not-allowed',
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  list: props => ({
    maxHeight: props.isOpen ? props.maxHeight : '0',
    overflowY: props.isOpen ? 'scroll' : 'hidden',
    position: 'absolute',
    transition: `all ${props.transitionTime}ms ease`,
    width: '100%',
    zIndex: props.zIndex,
  }),

  listItem: {
    cursor: 'pointer',
    backgroundColor: theme.colors.background.normal,

    '&:hover': {
      backgroundColor: theme.colors.lightGray.normal,
    },
  },

  selectedItemsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  selectedItem: {
    backgroundColor: theme.colors.lightGray.normal,
    display: 'inline',
  },
  selectedItemTitle: {
    display: 'inline',
  },

  closeIcon: {
    color: theme.colors.danger.normal,
  },
}));

export default useStyle;
